// extracted by mini-css-extract-plugin
module.exports = {"centerDiv":"SocialButton_centerDiv__a6uQo"};